// src/stone/icons/PeopleQuestion.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var PeopleQuestion = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M8.438 5.875a2.562 2.562 0 1 0 0 5.125 2.562 2.562 0 0 0 0-5.125M3.875 8.438a4.562 4.562 0 1 1 9.125 0 4.562 4.562 0 0 1-9.125 0M8.438 15.625c-2.381 0-4.125.447-5.237.866a1.65 1.65 0 0 0-1.076 1.546v2.713H14.75v-2.713c0-.68-.42-1.3-1.075-1.547M2.497 14.62c1.322-.498 3.304-.994 5.94-.994s4.62.496 5.942.993a3.65 3.65 0 0 1 2.371 3.419v4.713H.125v-4.713c0-1.508.932-2.877 2.372-3.418m5.94 1.006c2.38 0 4.125.447 5.238.865zM19.5 15a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" }),
      /* @__PURE__ */ jsx("path", { d: "M19.5 15a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-1.5-.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M20.024 3.27c-.854-.08-1.862.086-2.744.476l-.915.405-.81-1.83.915-.404c1.174-.519 2.524-.753 3.74-.639 1.194.113 2.454.587 3.14 1.698 1.29 2.084.251 4.322-1.478 5.789-.712.603-1.028 1.044-1.183 1.382-.15.327-.189.643-.189 1.103v1h-2v-1c0-.578.046-1.227.37-1.935.318-.696.864-1.36 1.708-2.076 1.382-1.171 1.602-2.354 1.071-3.211-.222-.36-.747-.676-1.625-.758" })
    ]
  }
);
var PeopleQuestion_default = PeopleQuestion;

export {
  PeopleQuestion,
  PeopleQuestion_default
};
